import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";
const containerClass = "mx-auto w-full max-w-[650px] px-6 sm:px-8 ";

export default function SelectAddressCanvas({ onClose, onSelectAddress }) {
  const [selectedAddress, setSelectedAddress] = useState(0);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
const addresses = [
  {
    name: "Veena Reddy",
    phone: "+916305881287",
    email: "sindhu@novatales.com",
    addressLine: "Endula Empresa, 5th Floor, Masjid Banda, Kondapur",
    city: "Hyderabad",
    state: "Telangana",
    pincode: "500084",
    country: "India",
  },
  {
    name: "Sindhu",
    phone: "+916305881287",
    email: "sindhu@novatales.com",
    addressLine: "Endula Empresa, 5th Floor, Masjid Banda, Kondapur",
    city: "Hyderabad",
    state: "Telangana",
    pincode: "500084",
    country: "India",
  },
];

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, []);

  return (
    <>
      {/* BACKDROP */}
      <div
        className="fixed inset-0 bg-[#113b1880] backdrop-blur-sm z-40"
        onClick={onClose}
      />

      {/* OFFCANVAS */}
      <div className="fixed right-0 top-0 h-full md:w-full lg:w-[50%] xl:w-[40%] bg-white z-50 animate-slideIn">
        <div className="h-full flex flex-col">
          {/* HEADER (ONLY CLOSE ICON) */}
          <div className="flex justify-end px-5 md:px-10 3xl:px-14 pt-8">
            <CloseIcon
              onClick={onClose}
              className="w-5 h-5 flex items-center justify-center rounded-full border border-[#29562f] text-[#29562f] cursor-pointer"
            />
          </div>

          {/* CONTENT */}
          <div className="flex-1 overflow-y-auto">
            <div className={`${containerClass} space-y-5 mt-4`}>
              <h2 className="font-lexend font-semibold text-[52px] text-[#333]">
                {" "}
                Select an address{" "}
              </h2>
              <p className="font-lexend font-semibold text-[26px] text-[#333]">
                Shipping address
              </p>

              {addresses.map((item, index) => (
                <div
                  key={index}
                  onClick={() => setSelectedAddress(index)}
                  className={`border rounded-xl p-5 flex gap-4 cursor-pointer transition ${
                    selectedAddress === index
                      ? "border-[#2f5d3a]"
                      : "border-[#dcdcdc]"
                  }`}
                >
                  {/* RADIO */}
                  <input
                    type="radio"
                    checked={selectedAddress === index}
                    onChange={() => setSelectedAddress(index)}
                    className="mt-1 accent-[#2f5d3a]"
                  />

                  {/* DETAILS */}
                  <div className="flex-1">
                    <p className="font-semibold font-lexend text-[20px] text-[#333]">
                      {item.name}
                    </p>

                    <p className="text-[#6d6d6d] text-[18px] font-lexend mt-2 leading-[20px] font-light">
                     {item.addressLine}, {item.city}, {item.state} - {item.pincode}, {item.country}
                    </p>

                    <p className="text-[#6d6d6d] text-[18px] font-lexend  font-light">
                      Phone number: {item.phone}
                    </p>

                    <p className="text-[#6d6d6d] text-[18px] font-lexend font-light">
                      Email: {item.email}
                    </p>
                  </div>

                  {/* 3 DOT MENU */}
                  <div className="relative">
                    <button
                      onClick={(e) => {
                        e.stopPropagation(); // prevent card click
                        setOpenMenuIndex(
                          openMenuIndex === index ? null : index,
                        );
                      }}
                    >
                      <MoreVertIcon />
                    </button>

                    {openMenuIndex === index && (
                      <div className="absolute right-0 top-6 shadow-md w-36 bg-white rounded-md z-20 overflow-hidden text-sm">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenMenuIndex(null);
                          }}
                          className="w-full text-left px-3 py-2 hover:bg-gray-100 font-lexend"
                        >
                          Edit
                        </button>

                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenMenuIndex(null);
                            console.log("Delete address", index);
                          }}
                          className="w-full text-left px-3 py-2 hover:bg-gray-100 font-lexend"
                        >
                          Remove
                        </button>

                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenMenuIndex(null);
                          }}
                          className="w-full text-left px-3 py-2 hover:bg-gray-100 font-lexend"
                        >
                          Set as Default
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              ))}

              {/* BILLING */}
              <label className="flex items-center gap-2 mt-4 font-lexend text-[#6d6d6d] text-[18px]">
                <input type="checkbox" className="accent-[#2f5d3a]" />
                Billing address same as shipping address
              </label>
            </div>
          </div>

          {/* FOOTER */}
          <div className="bg-[#e6d88f] py-4">
            <div className={`${containerClass} flex justify-end`}>
              <button
                onClick={() => {
                  onSelectAddress(addresses[selectedAddress]);
                  onClose();
                }}
                className="bg-[#2f5d3a] text-[#f4e391] text-[24px] px-6 py-2 rounded-lg font-lexend font-semibold"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
